import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';

@Component({
  selector: 'app-bom-comment-card',
  imports: [DatePipe, GcTextComponent, IpoTranslatePipe],
  templateUrl: './bom-comment-card.component.html',
  styleUrl: './bom-comment-card.component.scss',
})
export class BomCommentCardComponent {
  comment = input.required<string>();
  updatedBy = input<string | null>(null);
  updatedAt = input<string | null>(null);
}
